import { useQuery } from "@tanstack/react-query";
import { getQuotesOverview } from "../actions/quotesCharts.actions";

export const useQuotesCharts = () => {
  // const ent = useAppSelector(selectEntitlement(EBenefitTypes.METRICS_BASIC))

  // console.log("ent", ent);

  const token = sessionStorage.getItem("token");
  return useQuery({
    queryKey: ["quotesOverview"],
    queryFn: () => getQuotesOverview(token),
    staleTime: 1000 * 60 * 5,
    retry: false,
  });
};
